package ru.it_mozaika.sender.js.application.components.stores

import io.ktor.client.call.*
import io.ktor.http.*
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.router.useNavigate
import ru.it_mozaika.sender.common.models.StoreUpdateRequest
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.styles.styledDialog
import web.html.InputMode
import mui.icons.material.AddCircleOutlineSharp
import react.*
import react.dom.onChange
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import web.cssom.*

external interface AddNewStoreDialogProps: Props{
    var isOpen: Boolean
    var onClose: () -> Unit
}

val addNewStoreDialog = FC<AddNewStoreDialogProps> {props ->

    val (name, setName) = useState<String>()
    val (url, setUrl) = useState<String>()
    val navigate = useNavigate()
    val requestResultContext = useContext(RequestResultContext)
    Dialog{
        open = props.isOpen
        DialogTitle{
            + "Создание нового магазина"
        }
        DialogContent{
            Stack{
                direction = responsive(StackDirection.column)
                spacing = responsive(5.px)
                sx{
                    padding = 5.px
                }
                TextField{
                    id = "new-store-name-field"
                    label = ReactNode("Название:")
                    this.variant = FormControlVariant.outlined
                    required = true
                    error = name.isNullOrBlank()
                    this.onChange = { event ->
                        val value = event.target.asDynamic().value as String
                        setName(value)
                    }
                }
                TextField {
                    id = "new-store-name-id"
                    this.variant = FormControlVariant.outlined
                    label = ReactNode("Url: ")
                    required = true
                    error = url.isNullOrBlank()
                    this.onChange = { event ->
                        val value = event.target.asDynamic().value as String
                        setUrl(value)
                    }
                }
            }
        }
            DialogActions {
                sx{
                    alignItems = AlignItems.center
//                justifyContent = JustifyContent.center
                    marginRight = 15.px
                }
                Stack {

                    direction = responsive(StackDirection.row)
                    spacing = responsive(2)
                    Button {
                        variant = ButtonVariant.outlined
                        this.color = ButtonColor.secondary
                       +  "Создать"
                        this.disabled = name.isNullOrBlank() && url.isNullOrBlank()
                        this.onClick = {
                            if(!name.isNullOrBlank()&&!url.isNullOrBlank()) {
                                Http.put("/stores", StoreUpdateRequest(name, url)) { response ->

                                    requestResultContext.handleRequestRespond(response)
//                                    when (response.status) {
//                                        HttpStatusCode.NoContent -> {
//                                            showNotification("Новый элемент создан", NotyType.Success)
//                                            navigate("/stores/${response.headers["ID"].orEmpty()}")
//                                        }
//
//                                        HttpStatusCode.Forbidden -> {
//                                            showNotification("Недостаточно прав доступа", NotyType.Error)
//                                        }
//
//                                        HttpStatusCode.BadRequest -> {
//                                            showNotification(
//                                                "Ошибка в запросе: ${response.body<String>()}",
//                                                NotyType.Error
//                                            )
//                                        }
//                                    }

                                }
                            }
                            setName(null)
                            setUrl(null)
                        props.onClose()
//                                props.onClose()
                        }
                    }
                    Button {
                        + "Отмена"
                        color = ButtonColor.error
                        variant = ButtonVariant.outlined
                        onClick = {
                            setName(null)
                            setUrl(null)
                            props.onClose()
//                                props.onClose()
                        }
                    }
                }
            }

    }
}